export const HOME_ACTIVE_MENU = {
    PENDING_APPROVALS_ORDER: 'PENDING APPROVALS ORDER',
    MY_ORDERS: 'MY ORDERS',
    PENDING_FLEET_PROCESSING: 'FLEET PROCESSING',
    ALL_PENDING_APPROVAL: 'ALL PENDING APPROVALS'
}

export const COLUMN_FILTERS = {
    ORDER_DATE: 'orderDate',
    UPDATED_DATE: 'updatedDate',
    STATUS: 'status',
    REGION_NAME: 'regionName',
    UPDATED_BY: 'updatedBy',
    ASSIGNED_TO: 'assignedTo',
    REQUESTED_BY: 'requestedBy',
    REQUEST_TYPE: 'orderRequestType',
    COST_CENTER: 'costCenter',
    ITEM_STATUS: 'fleetItemStatus',
    QUANTITY: 'quantity',
    ORDER_ID: 'orderId',
    PRICE: 'orderPrice',
    FRS_ORDER_NUMBER: 'frsOrderNumber',
    COMMENT: 'comment',
    VEHICLE_TYPE: 'vehicleType',
    EQUIPMENT_TYPE: "equipmentType",
    MANUFACTURER: "manufacturer",
    MAKE: "make",
    MODEL: "model",
    CATEGORY: "category",
    DESCRIPTION:'description',
    YEAR: "year",
    DRIVE_TRAIN: "driveTrain",
    FUEL_TYPE: "fuelType",
    UPFIT: "upfit",
    BV_SPEC: "bvSpec",
    EQ_CLASS_CODE: "eqClassCode",
    EONE_DESCRIPTION: "eOneDescription",
    LAST_UPDATED_DATE: "lastUpdatedDate",
    ASSET_MODEL_ID : "assetModelId",
    JOB_TITLE_ID : "jobTitleId",
    CATALOG_ITEM_ID : 'catalogItemId',  
}

export const CATALOG_MANAGEMENT_ACTIVE_MENU = {
    VEHICLE: 'Vehicle',
    MOWERS: 'Mowers',
    CONSTRUCTION_EQUIPMENT: 'Construction Equipment',
    SNOW: 'Snow',
    STANDARIZED: 'Standardized',
    TRAILERS: 'Trailers',
    UTILITY_VEHICLE: 'Utility Vehicle',
    TREE_CARE: 'Tree Care',
    JOB_TITLES: 'Job Title',
}